import { SearchCategoryFilter, SearchSortFilter } from 'components';
import { useSearchResultsFilter } from 'state';

export default function SearchFilters() {
    const {
        dataType,
        setDataType,
        sort,
        setSort,
    } = useSearchResultsFilter();

    return(
        <div style={{display:'flex', flexDirection:'row', gap:'1rem'}}>
            <SearchCategoryFilter dataType={dataType} onChange={setDataType} />
            <SearchSortFilter
                searchSort={sort}
                onSearchSortChange={setSort}
            />
        </div>
    );
}